import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { CarouselV2 } from "@website/ui/carousel";
import { FALLBACK_IMAGE_MD, LazyImage } from "@website/ui/lazy-image";
import { Modal } from "@website/ui/modal";
import { dateFormat } from "@website/utils/date-format";
import { getImage } from "@website/utils/get-image";
import { numberConvert } from "@website/utils/number-convert";
import { ReserveGallerySinglePropertiesTypes } from "@website/widget/reserve-gallery-detail/reserve-gallery-single/reserve-gallery-single.types";
import toNumber from "lodash-es/toNumber";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
import { Fragment } from "react";
export const ReserveGallerySingle = properties => {
  const $ = _c(33);
  const {
    gallery,
    isInsideComment: t0,
    insideCommentProps
  } = properties;
  const isInsideComment = t0 === undefined ? false : t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router) {
    t1 = () => router.back();
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClose = t1;
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[2] !== gallery || $[3] !== insideCommentProps?.openModalCondition || $[4] !== insideCommentProps?.registeredDate || $[5] !== insideCommentProps?.roomName || $[6] !== insideCommentProps?.standNights || $[7] !== isInsideComment || $[8] !== onClose || $[9] !== router.locale || $[10] !== router.query?.item || $[11] !== router.query?.modal) {
    const startId = toNumber(router.query?.item) ?? 0;
    const isModalOpen = router.query?.modal === (isInsideComment ? insideCommentProps?.openModalCondition : "gallery-details");
    const startIndex = gallery.findIndex(t8 => {
      const {
        id
      } = t8;
      return toString(id) === toString(startId);
    });
    const filteredGallery = [...gallery.slice(startIndex), ...gallery.slice(0, startIndex)];
    T0 = Modal;
    t4 = "flex !h-full !w-full flex-col justify-center !rounded-none !bg-[#121212] p-0 md:box-content";
    t5 = onClose;
    t6 = isModalOpen;
    let t10;
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <MaterialIcon className="md:text-background text-xl text-gray-400" name="close" />;
      t10 = <span className="text-background hidden md:block">بستن</span>;
      $[19] = t10;
      $[20] = t9;
    } else {
      t10 = $[19];
      t9 = $[20];
    }
    if ($[21] !== onClose) {
      t7 = <div className="hover:bg-on-surface-high-emphasis flex h-[64px] items-center justify-end gap-2 px-6 py-4 md:h-[68px]"><div className="flex cursor-pointer flex-row gap-1" onClick={onClose}>{t9}{t10}</div></div>;
      $[21] = onClose;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    t2 = "size-full px-4 py-6";
    t3 = filteredGallery?.length > 0 && <CarouselV2 keyCarousel="reserve_gallery_single" list={filteredGallery.map((img, index) => <Fragment key={`${img?.media}_${img?.title}`}><div className="text-body-1 bg-on-surface-disable relative top-1 z-[1] mx-auto w-fit rounded-lg p-1 text-center text-white">{`${numberConvert(index + 1, {
          locale: router.locale
        })}/${numberConvert(filteredGallery.length, {
          locale: router.locale
        })}`}</div><div className="flex-col items-center justify-end"><LazyImage alt={img?.alt || img?.title} className="bg-outline-thin absolute left-1/2 top-1/2 flex size-auto max-h-full max-w-full -translate-x-1/2 -translate-y-1/2 align-middle" fallback={FALLBACK_IMAGE_MD.src} loading="lazy" src={getImage({
          src: img?.media
        })} title={img?.title} />{img?.title && <div className="text-caption bg-on-surface-disable absolute inset-x-0 top-2 z-[1] mx-auto mt-8 size-fit rounded-lg p-2 text-white">{numberConvert(img?.title, {
            locale: router.locale
          })}</div>}{isInsideComment && (insideCommentProps?.roomName || insideCommentProps?.registeredDate && insideCommentProps?.standNights) && <div className="absolute bottom-0 flex w-full flex-row items-center justify-between text-white"><div className="text-subtitle-2">{numberConvert(insideCommentProps?.roomName, {
              locale: router.locale
            })}</div><div className="text-overline"><span>{dateFormat(insideCommentProps?.registeredDate, {
                locale: "fa",
                template: "MMMM yyyy"
              })}</span><span className="px-1">{`(${numberConvert(insideCommentProps?.standNights, {
                locale: router.locale
              })} شب)`}</span></div></div>}</div></Fragment>)} mode="snap" options={{
      slides: {
        perView: 1
      }
    }} />;
    $[2] = gallery;
    $[3] = insideCommentProps?.openModalCondition;
    $[4] = insideCommentProps?.registeredDate;
    $[5] = insideCommentProps?.roomName;
    $[6] = insideCommentProps?.standNights;
    $[7] = isInsideComment;
    $[8] = onClose;
    $[9] = router.locale;
    $[10] = router.query?.item;
    $[11] = router.query?.modal;
    $[12] = T0;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    T0 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
  }
  let t8;
  if ($[23] !== t2 || $[24] !== t3) {
    t8 = <div className={t2}>{t3}</div>;
    $[23] = t2;
    $[24] = t3;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== T0 || $[27] !== t4 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8) {
    t9 = <T0 className={t4} onClose={t5} open={t6}>{t7}{t8}</T0>;
    $[26] = T0;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  return t9;
};